import { z } from "zod";

import { AssignStatus } from "@/enum/list.enum";

export const ReviewSessionSchema = z.object({
	id: z.string().uuid(),
	listId: z.number().nullable().optional(),
	listPersonIds: z.array(z.number()),
	assignStatus: z.array(z.nativeEnum(AssignStatus)).nullable().optional(),
	expiresAt: z.string(),
	createdAt: z.string(),
});

export const CreateReviewSessionRequestSchema = z.object({
	listId: z.number().optional(),
	listPersonIds: z.array(z.number()).min(1),
	assignStatus: z.array(z.nativeEnum(AssignStatus)).optional(),
});

export type ReviewSession = z.infer<typeof ReviewSessionSchema>;
export type CreateReviewSessionRequest = z.infer<typeof CreateReviewSessionRequestSchema>;
